import type { ReactNode } from "react";

// One row's panel (BRK-S349): a location, a class code, a person. RepeatableRows
// draws it around a row a broker can edit, with Remove as its action, and a
// step's Review draws the same panel around what the row held, so the two read
// alike. A region named by its title, so nested rows stay addressable
// ("Class code 1" inside "Location 2").

export type RowHeadingLevel = 3 | 4 | 5;

const HEADING = { 3: "h3", 4: "h4", 5: "h5" } as const;

export function RowPanel({
  title,
  headingLevel = 3,
  action,
  children,
}: {
  title: string;
  /** One level under whatever holds it: h4 inside a card titled in h3. */
  headingLevel?: RowHeadingLevel;
  action?: ReactNode;
  children: ReactNode;
}) {
  const Heading = HEADING[headingLevel];
  return (
    <section
      aria-label={title}
      className="flex min-w-0 flex-col gap-3 rounded-lg border border-brk-border bg-brk-panel p-3 sm:p-4"
    >
      <div className="flex items-center justify-between gap-2">
        <Heading className="text-body font-medium text-brk-text">
          {title}
        </Heading>
        {action}
      </div>
      {children}
    </section>
  );
}
